<script>
  import {
    layoutComputed
  } from "@/state/helpers";
  import {
    SimpleBar
  } from "simplebar-vue3";

    import axios from 'axios';
    
  export default {
    components: {
      SimpleBar
    },
    data() {
      return {
        settings: {
          minScrollbarLength: 60,
        },
        menu: JSON.parse(localStorage.getItem('menus')),
      };
    },
    computed: {
      ...layoutComputed,
      layoutType: {
        get() {
          return this.$store ? this.$store.state.layout.layoutType : {} || {};
        },
      },
    },

    watch: {
      $route: {
        handler: "onRoutechange",
        immediate: true,
        deep: true,
      },
    },

    mounted() {
      if (document.querySelectorAll(".navbar-nav .collapse")) {
        let collapses = document.querySelectorAll(".navbar-nav .collapse");
        collapses.forEach((collapse) => {
          // Hide sibling collapses on `show.bs.collapse`
          collapse.addEventListener("show.bs.collapse", (e) => {
            e.stopPropagation();
            let closestCollapse = collapse.parentElement.closest(".collapse");
            if (closestCollapse) {
              let siblingCollapses =
                closestCollapse.querySelectorAll(".collapse");
              siblingCollapses.forEach((siblingCollapse) => {
                if (siblingCollapse.classList.contains("show")) {
                  let aChild = siblingCollapse.parentNode.firstChild;
                  if (aChild.hasAttribute("aria-expanded")){
                    aChild.setAttribute("aria-expanded", "false");
                  }
                  siblingCollapse.classList.remove("show");
                }
              });
            } else {
              let getSiblings = (elem) => {
                // Setup siblings array and get the first sibling
                let siblings = [];
                let sibling = elem.parentNode.firstChild;
                // Loop through each sibling and push to the array
                while (sibling) {
                  if (sibling.nodeType === 1 && sibling !== elem) {
                    siblings.push(sibling);
                  }
                  sibling = sibling.nextSibling;
                }
                return siblings;
              };
              let siblings = getSiblings(collapse.parentElement);
              siblings.forEach((item) => {
                if (item.childNodes.length > 2)
                  item.firstElementChild.setAttribute("aria-expanded", "false");
                let ids = item.querySelectorAll("*[id]");
                ids.forEach((item1) => {
                  let aChild = item1.parentNode.firstChild;
                  if (aChild.hasAttribute("aria-expanded")){
                    aChild.setAttribute("aria-expanded", "false");
                  }
                  item1.classList.remove("show");
                  if (item1.childNodes.length > 2) {
                    let val = item1.querySelectorAll("ul li a");

                    val.forEach((subitem) => {
                      if (subitem.hasAttribute("aria-expanded"))
                        subitem.setAttribute("aria-expanded", "false");
                    });
                  }
                });
              });
            }
          });

          // Hide nested collapses on `hide.bs.collapse`
          collapse.addEventListener("hide.bs.collapse", (e) => {
            e.stopPropagation();
            let childCollapses = collapse.querySelectorAll(".collapse");
            childCollapses.forEach((childCollapse) => {
              let childCollapseInstance = childCollapse;
              childCollapseInstance.hide();
            });
          });
        });
      }

    //   this.GetMenu();
    },

    methods: {

        GetMenu() {

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'menu/my')
            .then(response => {

                if (response) {
                    this.menu=response.data;
                        //   console.log(response.data);
                    } else {
                        this.messageBag = ['No record.'];
                        this.isLoadingToDisplayData=false;
                    }
            }).catch(error => {
                    this.messageBag = [error.error];
                    this.isLoadingToDisplayData=false;
			});
            
		},

      onRoutechange(ele) {
        this.initActiveMenu(ele.path);
        if (document.getElementsByClassName("mm-active").length > 0) {
          const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
          if (currentPosition > 500)
            if (this.$refs.isSimplebar)
              this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
        }
      },

      initActiveMenu(ele) {
        setTimeout(() => {
          if (document.querySelector("#navbar-nav")) {
            // let a = document.querySelector("#navbar-nav").querySelector('[href="' + ele + '"]');
            let a = document.querySelector("#navbar-nav").querySelector('[href="' + process.env.VUE_APP_BASE_URL + ele + '"]');
            // console.log(ele);
            if (a) {
              a.classList.add("active");
              let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
              if (parentCollapseDiv) {
                parentCollapseDiv.classList.add("show");
                parentCollapseDiv.parentElement.children[0].classList.add("active");
                parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
                if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                  parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                  if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add(
                      "active");
                }
              }
            }
          }
        }, 0);
      },
    },
  };
</script>

<template>
  <div class="container-fluid">
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'twocolumn'">
      <SimpleBar class="navbar-nav" id="navbar-nav">
      </SimpleBar>
    </template>

    <template v-else>
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li class="menu-title">
          <!-- <span data-key="t-menu"> {{ $t("t-menu") }}</span> -->
        </li>
        <!-- end Dashboard Menu -->
        <!-- v-bind="{id: item.name} -->
        <li v-for="(item, index) in menu" :key="index" class="nav-item">
            <span v-if="item.menu['0']">
                <a class="nav-link menu-link" :href="item.tab_link" data-bs-toggle="collapse" role="button" aria-expanded="false">
                    <i :class="item.tab_icon"></i>
                    <span data-key="t-pages">{{ item.tab_name }}</span>
                </a>
                <div class="collapse menu-dropdown" v-bind="{id: item.tab_link_}">

                    <ul v-for="(itemMenu, index) in item.menu" :key="index" class="nav nav-sm flex-column">
                        <li class="nav-item">
                            <router-link :to="itemMenu.tab_link" class="nav-link"> 
                                {{ itemMenu.tab_name }}
                            </router-link>
                        </li>
                    </ul>    
                </div>
            </span>
            <span v-else>
                
                <li class="nav-item">
                    <router-link class="nav-link menu-link" :to="item.tab_link">
                        <i :class="item.tab_icon"></i>
                            <span data-key="t-widgets">{{ item.name }}</span>
                    </router-link>
                </li> 

            </span>
        </li>

        
        <!-- <li class="nav-item">
          <router-link class="nav-link menu-link" to="/widgets">
            <i class="ri-honour-line"></i>
                <span data-key="t-widgets">{{ $t("t-widgets") }}</span>
          </router-link>
        </li>  -->
        
      </ul>
    </template>
  </div>
  <!-- Sidebar -->
</template>